import React from "react";
import ApiUrl from "./ApiUrl";

export const UpdateHeaderBlock = (data) => {
   // lista de todos los usuarios
   // endDate es el total de horas
   const service = `${ApiUrl}headerBlocks/update`;
   const options = {
      method: "POST",
      //mode: "no-cors",
      body: data,
      headers: {
         "Content-Type": "multipart/form-data",
      },
   };
   delete options.headers["Content-Type"];
   return fetch(service, options);
};
export const InfoHeaderBlock = (dat) => {
   // lista de todos los usuarios
   // endDate es el total de horas
   const service = `${ApiUrl}headerBlocks/list`;
   const data = {...dat, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};

/// home

export const ListSlides = () => {
   // lista de todos los usuarios
   // endDate es el total de horas
   const service = `${ApiUrl}slidesHome/list`;
   return fetch(service);
};

//slidesHome
export const CreateSlideHome = (data) => {
   // lista de todos los usuarios
   // endDate es el total de horas
   const service = `${ApiUrl}slidesHome/register`;
   const options = {
      method: "POST",
      //mode: "no-cors",
      body: data,
      headers: {
         "Content-Type": "multipart/form-data",
      },
   };
   delete options.headers["Content-Type"];
   return fetch(service, options);
};
export const UpdateSlideHome = (data) => {
   // lista de todos los usuarios
   // endDate es el total de horas
   const service = `${ApiUrl}slidesHome/update`;
   const options = {
      method: "POST",
      //mode: "no-cors",
      body: data,
      headers: {
         "Content-Type": "multipart/form-data",
      },
   };
   delete options.headers["Content-Type"];
   return fetch(service, options);
};
export const DeleteSlideHome = (idSlideHome) => {
   // lista de todos los usuarios
   // endDate es el total de horas
   const service = `${ApiUrl}slidesHome/delete`;
   const data = {idSlideHome, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
// academy
export const ListAcademyService = () => {
   const service = `${ApiUrl}domecqAcademyContent/list`;
   return fetch(service);
   /* 
   const data = {...dat, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   }); */
};

export const UpdateDomecqAcademy = (data) => {
   // lista de todos los usuarios
   // endDate es el total de horas
   const service = `${ApiUrl}domecqAcademyContent/update`;
   const options = {
      method: "POST",
      //mode: "no-cors",
      body: data,
      headers: {
         "Content-Type": "multipart/form-data",
      },
   };
   delete options.headers["Content-Type"];
   return fetch(service, options);
};

// blocks
export const ListHomeBlocks = () => {
   const service = `${ApiUrl}homeBlocks/list`;
   return fetch(service);
};
export const UpdateBlockHome = (dat) => {
   const service = `${ApiUrl}homeBlocks/update`;
   const data = {...dat, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};

export const CreateBlockHome = (dat) => {
   const service = `${ApiUrl}homeBlocks/register`;
   const data = {...dat, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};

export const CreateResourceCourse = (data) => {
   // lista de todos los usuarios
   // endDate es el total de horas
   const service = `${ApiUrl}resources/register`;
   const options = {
      method: "POST",
      //mode: "no-cors",
      body: data,
      headers: {
         "Content-Type": "multipart/form-data",
      },
   };
   delete options.headers["Content-Type"];
   return fetch(service, options);
};

export const CreateThemeCourse = (dat) => {
   const service = `${ApiUrl}temaryClasses/register`;
   const data = {...dat, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const UpdateThemeCourse = (dat) => {
   const service = `${ApiUrl}temaryClasses/update`;
   const data = {...dat, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const CreateSubthemeCourse = (dat) => {
   const service = `${ApiUrl}temarySubclasses/register`;
   const data = {...dat, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const UpdateSubthemeCourse = (dat) => {
   const service = `${ApiUrl}temarySubclasses/update`;
   const data = {...dat, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};

export const getTestitmonialsList = () => {
   const service = `${ApiUrl}testimonials/list`;
   return fetch(service);
};
